import React, { Component } from "react";

import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import EditQuestion from "../../../../components/QuestionBank/EditQuestion";
import QuestionCreatorBottomMenu from "../../../../components/QuestionCreator/QuestionCreatorBottomMenu/QuestionCreatorBottomMenu";
import QuestionCreatorHeaderMenu from "../../../../components/QuestionCreator/QuestionCreatorHeaderMenu/QuestionCreatorHeaderMenu";
import QuestionCreatorItemsMenu from "../../../../components/QuestionCreator/QuestionCreatorItemsMenu/QuestionCreatorItemsMenu";
import TextEditor from "../../../../components/TextEditor/TextEditor";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./styles.css";

class QuestionCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showQuestionEditModal: false,
      loadingData: true,
      // upToDate: false,
      nonTimerCalls: 0,

      createActivity: this.props.onActivity,
      // activityIndex: this.props.index,
      activityValueShare: this.props.valueShare || {
        totalValue: undefined,
        questionsAmount: undefined,
        shareValue: undefined
      },
      // updatingData: false,

      questionId: null,
      grade: null,
      author: null,
      user_id: null,
      year: null,
      ability: 1,
      // module: 1,
      // difficultyLevel: 1,
      questionDescription: null,
      currentQuestionTypeId: 1,
      items: [],
      questionFeedback: null,
      questionFeedbackOn: false,
      released: false,
      private: true,

      moreInfo: false,

      grades: [
        {
          grade: 1,
          name: "1º ano"
        },
        {
          grade: 2,
          name: "2º ano"
        },
        {
          grade: 3,
          name: "3º ano"
        },
        {
          grade: 4,
          name: "4º ano"
        },
        {
          grade: 5,
          name: "5º ano"
        },
        {
          grade: 6,
          name: "6º ano"
        },
        {
          grade: 7,
          name: "7º ano"
        },
        {
          grade: 8,
          name: "8º ano"
        },
        {
          grade: 9,
          name: "9º ano"
        },
        {
          grade: 10,
          name: "1ª série"
        },
        {
          grade: 11,
          name: "2ª série"
        },
        {
          grade: 12,
          name: "3ª série"
        }
      ],
      types: [
        {
          id: 1,
          name: "Discursiva"
        },
        {
          id: 2,
          name: "Múltipla Escolha"
        },
        {
          id: 3,
          name: "Múltipla Resposta"
        },
        {
          id: 4,
          name: "Verdadeiro ou Falso"
        }
      ],
      abilities: []
      // modules: []
    };

    this.typeChanger = this.handleTypeChange.bind(this);

    // this.changeQuestionDescription =
    //   this.changeQuestionDescriptionContent.bind(this);

    this.showMoreInfo = this.toggleMoreInfo.bind(this);

    this.toggleQuestionFeedback =
      this.changeQuestionFeedbackExibition.bind(this);
    this.changeQuestionFeedback = this.changeQuestionFeedbackContent.bind(this);
    this.yearChanger = this.changeQuestionYear.bind(this);
    this.authorChanger = this.changeAuthor.bind(this);
    this.gradeChanger = this.changeGrade.bind(this);
    this.difficultyChanger = this.changeDifficultyLevel.bind(this);
    this.abilityChanger = this.changeAbility.bind(this);
    this.moduleChanger = this.changeModule.bind(this);
    this.privateChanger = this.changePrivate.bind(this);

    this.dataUpdater = this.updateData.bind(this);

    this.questionDeleter = this.deleteQuestion.bind(this);
    this.questionDuplicator = this.duplicateQuestion.bind(this);
    this.questionEditor = this.editQuestion.bind(this);
  }

  componentDidMount() {
    if (!this.state.createActivity) {
      this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    }

    let editParamId;

    if (this.state.createActivity) editParamId = this.props.questionId;
    else editParamId = this.props.match.params.id;

    if (!editParamId) this.createNewQuestion();
    else this.pullQuestion(editParamId);

    if (!this.state.createActivity || this.props.types) {
      this.setState({ types: this.props.types });
    } else {
      axios
        .get(`${URL.api}evaluation/type_question/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(typesResponse => {
          this.setState({ types: typesResponse.data.data });
        });
    }

    if (!this.state.createActivity || this.props.abilities) {
      this.setState({ abilities: this.props.abilities });
    } else {
      axios
        .get(`${URL.api}classification/ability/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(abilitiesResponse => {
          if (abilitiesResponse.data.success) {
            this.setState({ abilities: abilitiesResponse.data.data });
          }
        });
    }

    // this.interval = setInterval(() => {
    //   if (this.state.nonTimerCalls === 0) {
    //     this.updateData();
    //   }

    //   this.setState({ nonTimerCalls: 0 });
    // }, 45 * 1000);

    // return () => clearInterval(this.interval);
  }

  createNewQuestion(duplicatedObj, __duplicatedQuestion) {
    const obj = duplicatedObj || {
      description: JSON.stringify([
        { type: "paragraph", children: [{ text: "" }] }
      ]),
      feedback: this.state.questionFeedback,
      grade: 10,
      author: this.props.user.user.name,
      year: new Date().getFullYear(),
      ability_id: 1,
      L_id: 1,
      type_question_id: 1,
      user_id: this.props.user.user.id,
      source_id: 1,
      released: false,
      private: true,
      options: []
    };

    axios
      .post(`${URL.api}evaluation/question/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          if (__duplicatedQuestion) {
            this.props.questionDuplicator(
              this.state.questionId,
              resp.data.data
            );
          } else {
            this.setState({
              // upToDate: true,
              questionId: resp.data.data,
              loadingData: false
            });
            if (!this.state.createActivity)
              this.props.history.push(`/question/create/${resp.data.data}`);
            else {
              this.pullQuestion(resp.data.data);
              this.props.listChanger(resp.data.data, this.props.index);
            }
          }
        }
      });
  }

  pullQuestion(editParamId) {
    axios
      .get(`${URL.api}evaluation/question/singleView/${editParamId}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          const feedbackOn =
            resp.data.data.feedback &&
            resp.data.data.feedback !==
              '[{"type":"paragraph","children":[{"text":""}]}]';

          let items = resp.data.data.options.map((item, index) => {
            const itemFeedbackOn = item.feedback !== null;

            item = {
              itemIndex: index,
              description: item.description,
              itemFeedbackOn,
              feedback: item.feedback,
              check: item.check_value,
              fatherItemId: item.father_option_id,
              newItem: false
            };

            return item;
          });

          if (resp.data.data.options.length === 0) {
            items = [
              {
                itemIndex: 0,
                description: '[{"type":"paragraph","children":[{"text":""}]}]',
                itemFeedbackOn: false,
                feedback: null,
                check: true,
                fatherItemId: null,
                newItem: false
              }
            ];
          }

          items.push({
            itemIndex: items.length,
            description: '[{"type":"paragraph","children":[{"text":""}]}]',
            feedback: null,
            check: false,
            fatherItemId: null,
            newItem: true
          });

          this.setState({
            loadingData: false,
            // upToDate: true,

            questionId: resp.data.data.id,
            grade: resp.data.data.grade,
            author: resp.data.data.author,
            user_id: resp.data.data.user_id,
            year: resp.data.data.year,
            questionDescription: resp.data.data.description,
            currentQuestionTypeId: resp.data.data.type_question_id,
            items,
            questionFeedbackOn: feedbackOn,
            questionFeedback: resp.data.data.feedback,
            released: resp.data.data.released,
            private: resp.data.data.private,
            ability: resp.data.data.ability_id
          });
        }
      });
  }

  deleteQuestion() {
    // const obj = {
    //   id: this.state.questionId
    // }

    // axios.post(URL.api + 'evaluation/question/delete', obj, { headers: { Authorization: 'Bearer ' + this.props.user.token } })
    //   .then(
    //     resp => {
    //       if (!resp.data.success) {
    //         alert('Questão não encontrada');
    //       }
    //     }
    //   )

    if (this.state.createActivity)
      return this.props.questionDeleter(this.props.index);
  }

  editQuestion() {
    this.setState({ showQuestionEditModal: true });
  }

  handleIsSaved = () => {
    this.props.shouldUpdateList(this.props.questionId);
    this.setState({ showQuestionEditModal: false });
  };

  duplicateQuestion() {
    if (!this.state.createActivity) return;

    const itemsToFilter = this.state.items.filter(item => !item.newItem);
    const itemsToSend = itemsToFilter.map(item => {
      item = {
        description: item.description,
        check_value: item.check,
        feedback: item.feedback,
        father_option_id: item.fatherItemId
      };

      return item;
    });

    const obj = {
      description: this.state.questionDescription,
      feedback: this.state.questionFeedback,
      grade: this.state.grade,
      author: this.state.author,
      year: this.state.year,
      ability_id: this.state.ability,
      L_id: 1,
      type_question_id: this.state.currentQuestionTypeId,
      user_id: this.props.user.user.id,
      source_id: 1,
      released: false,
      private: this.state.private,
      options: itemsToSend
    };

    this.createNewQuestion(obj, true);
  }

  updateData() {
    this.setState(prevState => ({
      nonTimerCalls: prevState.nonTimerCalls + 1
      // updatingData: true
    }));

    const itemsToFilter = this.state.items.filter(item => !item.newItem);
    const itemsToSend = itemsToFilter.map(item => {
      item = {
        description: item.description,
        check_value: item.check,
        feedback: item.feedback,
        father_option_id: item.fatherItemId
      };

      return item;
    });

    const obj = {
      id: this.state.questionId,
      description: this.state.questionDescription,
      feedback: this.state.questionFeedback,
      grade: this.state.grade,
      author: this.state.author,
      ability_id: this.state.ability,
      L_id: 1,
      type_question_id: this.state.currentQuestionTypeId,
      user_id: this.state.user_id,
      source_id: 1,
      released: this.state.released,
      private: this.state.private,
      canceled: false,
      options: itemsToSend
    };

    axios
      .post(`${URL.api}evaluation/question/update`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          // eslint-disable-next-line react/no-unused-state
          this.setState({ upToDate: true, updatingData: false });
        } else {
          // eslint-disable-next-line react/no-unused-state
          this.setState({ updatingData: false });
        }
      })
      .catch(err => {
        // eslint-disable-next-line react/no-unused-state
        this.setState({ updatingData: false });
      });
  }

  handleTypeChange(newTypeId) {
    let changeToRadioHandler = this.state.items.map(item => {
      item.check && ++changeToRadioHandler;
      return 0;
    });

    if (newTypeId === 2 && changeToRadioHandler > 1) {
      const itemToSave = this.state.items.find(item => item.check).itemIndex;

      const items = this.state.items.map((item, index) => {
        if (index !== itemToSave) {
          item = {
            itemIndex: item.itemIndex,
            description: item.description,
            itemFeedbackOn: item.itemFeedbackOn,
            feedback: item.feedback,
            check: false,
            fatherItemId: item.fatherItemId,
            newItem: item.newItem
          };
        }

        return item;
      });

      this.setState(
        () => ({
          currentQuestionTypeId: newTypeId,
          items
        }),
        () => this.updateData()
      );
    } else {
      this.setState(
        () => ({ currentQuestionTypeId: newTypeId }),
        () => this.updateData()
      );
    }
  }

  changeQuestionDescriptionContent = newDescription => {
    () => {
      // this.setState(
      //   () => ({
      //     questionDescription: JSON.stringify(newDescription),
      //     upToDate: false
      //   }),
      //   () =>
      //     localStorage.setItem(
      //       `question-${this.state.questionId}-description`,
      //       this.state.questionDescription
      //     )
      // );
    };
  };

  changeQuestionFeedbackExibition() {
    this.setState(prevState => ({
      questionFeedbackOn: !prevState.questionFeedbackOn
    }));
    /* if (!this.setState.questionFeedbackOn && this.state.questionFeedback === '[{"type":"paragraph","children":[{"text":""}]}]') {
      this.setState((prevState) => ({ questionFeedbackOn: !prevState.questionFeedbackOn }));
    } 
    else {
      if (window.confirm('Você realmente deseja apagar seu feedback?')) {
        this.setState((prevState) => ({ questionFeedbackOn: !prevState.questionFeedbackOn, questionFeedback: '[{"type":"paragraph","children":[{"text":""}]}]' }));
        return;
      }
      else return;
    } */
  }

  changeQuestionFeedbackContent(newFeedback) {
    this.setState(
      () => ({
        questionFeedback: JSON.stringify(newFeedback)
        // upToDate: false
      }),
      () =>
        localStorage.setItem(
          `question-${this.state.questionId}-feedback`,
          this.state.questionFeedback
        )
    );
  }

  changeQuestionYear(newYear) {
    this.setState({ year: newYear });
  }

  changeAuthor(newAuthor) {
    this.setState({ author: newAuthor });
  }

  changeGrade(newGrade) {
    this.setState(
      () => ({ grade: newGrade }),
      () => this.updateData()
    );
  }

  changeDifficultyLevel(newLevel) {
    this.setState(
      // eslint-disable-next-line react/no-unused-state
      () => ({ difficultyLevel: newLevel }),
      () => this.updateData()
    );
  }

  changeModule(newModule) {
    this.setState(
      // eslint-disable-next-line react/no-unused-state
      () => ({ module: newModule }),
      () => this.updateData()
    );
  }

  changeAbility(newAbility) {
    this.setState(
      () => ({ ability: newAbility }),
      () => this.updateData()
    );
  }

  changePrivate(newPrivate) {
    this.setState(
      () => ({ private: newPrivate }),
      () => this.updateData()
    );
  }

  toggleMoreInfo() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ moreInfo: !this.state.moreInfo });
  }

  render() {
    return (
      <>
        {!this.props.onActivity && (
          <Breadcrumb
            current={this.props.currentRoute}
            items={[{ path: "/question/list", to: "/question/list" }]}
          />
        )}
        {this.state.loadingData === false ? (
          <div className="question-creator-container">
            <QuestionCreatorHeaderMenu
              questionId={this.state.questionId}
              currentTypeId={this.state.currentQuestionTypeId}
              typeChanger={this.typeChanger}
              itemTypes={this.state.types} // aqui não tá vindo os types
              updater={this.dataUpdater}
              onActivity={this.state.createActivity}
              questionValue={this.props.questionValue}
              valueShare={
                this.props.valueShare || {
                  totalValue: this.state.activityValueShare.totalValue,
                  questionsAmount:
                    this.state.activityValueShare.questionsAmount,
                  shareValue: this.state.activityValueShare.shareValue
                }
              }
              questionValueChanger={this.props.questionValueChanger}
              questionDuplicator={this.questionDuplicator}
              questionEditor={this.questionEditor}
              questionDeleter={this.questionDeleter}
              history={this.props.history}
              readOnly={
                true ||
                this.props.disabled ||
                this.props.user.user.id !== this.state.user_id
              }
              disabled={this.props.disabled}
              released={this.state.released}
            />
            <TextEditor
              userId={this.props.user.user.id}
              editorType={{ name: "description", id: 1 }}
              questionId={this.state.questionId}
              changeQuestionDescription={this.changeQuestionDescription}
              textContent={this.state.questionDescription}
              readOnly={true || this.props.user.user.id !== this.state.user_id}
              updater={this.dataUpdater}
            />
            {this.state.currentQuestionTypeId !== 1 && (
              <QuestionCreatorItemsMenu
                questionState={this.state}
                itemsData={this.state.items}
                updater={this.dataUpdater}
                updateState={e => this.setState(e)}
                readOnly={
                  true ||
                  this.props.disabled ||
                  this.props.user.user.id !== this.state.user_id
                }
              />
            )}
            <QuestionCreatorBottomMenu
              showQuestionFeedback={this.state.questionFeedbackOn}
              toggleQuestionFeedback={this.toggleQuestionFeedback}
              changeQuestionFeedback={this.changeQuestionFeedback}
              feedbackContent={this.state.questionFeedback}
              questionId={this.state.questionId}
              onActivity={this.state.createActivity}
              updater={this.dataUpdater}
              history={this.props.history}
              moreInfo={this.state.moreInfo}
              showMoreInfo={this.showMoreInfo}
              author={this.state.author}
              authorChanger={this.authorChanger}
              questionYear={this.state.year}
              yearChanger={this.yearChanger}
              grades={this.state.grades}
              gradeChanger={this.gradeChanger}
              difficultyChanger={this.difficultyChanger}
              abilities={this.state.abilities}
              ability={this.state.ability}
              abilityChanger={this.abilityChanger}
              private={this.state.private}
              privateChanger={this.privateChanger}
              readOnly={
                true ||
                this.props.disabled ||
                this.props.user.user.id !== this.state.user_id
              }
            />
          </div>
        ) : (
          <div className="question-creator-container">
            <div className="d-flex justify-content-between">
              <div
                className="question-creator-skeleton"
                style={{ width: "28%", height: "1rem", margin: "8px 0" }}
              />
              <div
                className="question-creator-skeleton"
                style={{ width: "32%", height: "1rem", margin: "8px 0" }}
              />
            </div>
            <div className="my-2">
              <div
                className="question-creator-skeleton"
                style={{ width: "90%", height: "1.5rem", margin: "8px 0" }}
              />
              <div
                className="question-creator-skeleton"
                style={{ width: "30%", height: "1.5rem", margin: "8px 0" }}
              />
            </div>
            <div
              className="question-creator-skeleton"
              style={{ width: "100%", height: "8rem", margin: "8px 0" }}
            />
          </div>
        )}
        {!this.props.onActivity && <ProtectedRoute />}
        <CModal
          show={this.state.showQuestionEditModal}
          onClose={() => this.setState({ showQuestionEditModal: false })}
          centered
          backdrop="static"
          size="lg"
        >
          <CModalHeader closeButton>
            <CModalTitle>Editar Questão</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <>
              {this.state.questionId && this.state.showQuestionEditModal && (
                <EditQuestion
                  questionId={this.state.questionId}
                  handleIsSaved={this.handleIsSaved}
                />
              )}
            </>
          </CModalBody>
        </CModal>

        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionCreate);
